import React from "react";
import {connect} from "react-redux";

const LoadingSpinner = ({ isMobile }) => {
    return <svg width="30" height="30" viewBox="0 0 62 62" fill="none"
                xmlns="http://www.w3.org/2000/svg" className="spinner">
        <path d="M31 14.1347V4.38776" stroke="white" strokeWidth="4.08163"
              strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.1*/}
        <path opacity="1" d="M44.3057 7.9552L39.4404 16.3797" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.15*/}
        <path opacity="1" d="M45.6045 22.5674L54.0453 17.6939" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.25*/}
        <path opacity="1" d="M57.6122 31.0001H47.8652" stroke="white" strokeWidth="4.08163"
              strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.35*/}
        <path opacity="1" d="M45.6201 39.4408L54.0446 44.3061" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.45*/}
        <path opacity="1" d="M44.3061 54.0449L39.4326 45.6041" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.55*/}
        <path opacity="1" d="M31 47.8653V57.6122" stroke="white" strokeWidth="4.08163"
              strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.65*/}
        <path opacity="1" d="M17.6943 54.0449L22.5596 45.6204" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.75*/}
        <path opacity="1" d="M16.3959 39.4326L7.95508 44.3061" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.8*/}
        <path opacity="1" d="M4.3877 31.0001H14.1346" stroke="white" strokeWidth="4.08163"
              strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 0.9*/}
        <path opacity="1" d="M16.3796 22.5592L7.95508 17.6939" stroke="white"
              strokeWidth="4.08163" strokeMiterlimit="10" strokeLinecap="round"/>
        {/* 1*/}
        <path d="M17.6943 7.9552L22.5678 16.396" stroke="white" strokeWidth="4.08163"
              strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
}

export default connect((state) => {
    return {
        isMobile: state.isMobile
    };
})(LoadingSpinner);